import { render, staticRenderFns } from "./OpinionFeedback.vue?vue&type=template&id=59a19612&scoped=true"
import script from "./OpinionFeedback.vue?vue&type=script&lang=js"
export * from "./OpinionFeedback.vue?vue&type=script&lang=js"
import style0 from "./OpinionFeedback.vue?vue&type=style&index=0&id=59a19612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a19612",
  null
  
)

export default component.exports